import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import * as Filters from '~/components/Shared/Filters_DEPRECATED/types';
import { useToast } from '~/eds/src/components/hooks/useToast';
import { useDebouncedCallback } from '~/hooks/useDebouncedCallback';
import { api } from '~/redux/api/createApi';
import { DashboardEntityType } from '~/redux/api/methods/dashboardV2';
import { coerceRtkqError } from '~/redux/api/utils';
import { SearchFilter } from '~/types/DashboardV2';

export const getAsyncOptionsContainer = (
  searchFilter: SearchFilter,
  type: DashboardEntityType = 'ticket',
) => {
  const AsyncOptionsContainer: Filters.FieldRendererProps = ({
    Component,
    innerProps,
  }) => {
    const [getFilterSuggestions, result] =
      api.endpoints.getFilterSuggestionsV2.useLazyQuery();

    const debouncedGetFieldValues = useDebouncedCallback(getFilterSuggestions);
    const { toast } = useToast();
    const intl = useIntl();

    const { data: response, error, isFetching } = result;

    const selectAllCount = response?.meta?.select_all_count;

    const data = response?.data?.map((entity) => entity.attributes);
    const asyncOptions = {
      data,
      error,
      isFetching,
      selectAllCount,
    };
    const fetchOptions = (substringQuery = '') => {
      debouncedGetFieldValues({
        filterId: searchFilter.id,
        type,
        query: substringQuery,
      });
    };
    const asyncProps = {
      asyncOptions,
      onMount: fetchOptions,
      onQuery: fetchOptions,
    };

    useEffect(() => {
      if (error) {
        toast({
          message:
            coerceRtkqError(error)?.response?.data?.detail ||
            intl.formatMessage({
              id: 'AsyncOptionsContainer.errorLoadingSuggestions',
              defaultMessage:
                'An error occurred while loading field suggestions.',
              description: 'Error message when field suggestions fail to load',
            }),
          status: 'danger',
        });
      }
    }, [error]);

    return <Component asyncProps={asyncProps} innerProps={innerProps} />;
  };
  return AsyncOptionsContainer;
};
